import { emptyPagedCollection, IPagingData, MediaInfoDto } from '@sr/dto';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { IRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import { mediaListApi } from './api-slice';


export const useMediaList = (pagination: IPagingData, filter?: URLSearchParams,) => {

  const { data, isLoading, error } = mediaListApi.useGetMediaListQuery(
    { paging: pagination, filter: filter?.toString() || '' },
    { refetchOnMountOrArgChange: true });

  const result: IRemotePagedCollection<MediaInfoDto> = {
    collection: data || emptyPagedCollection,
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading,
  };

  return result;
};

export const useMedia = (id: number, pagination: IPagingData, filter?: URLSearchParams) => {
  const { data, isLoading, error } = mediaListApi.useGetMediaQuery(
    { 
      id,
      paging: pagination, 
      filter: filter?.toString() || '' 
    },
    { 
      refetchOnMountOrArgChange: true 
    }
  );

  const result: IRemotePagedCollection<MediaInfoDto> = {
    collection: data || emptyPagedCollection,
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading,
  };

  return result;
};